import type { useOpenNotification } from 'utils/antd/notification-toasts';

import type { ErrorResponse } from 'api';

import { TRANSLATIONS } from './constants';

export function formatErrors(errors: ErrorResponse): string {
  const details = errors.error?.details;
  if (!details) {
    return '';
  }

  const detailsString = Object.entries(details)
    .map(([fieldName, fieldErrors]) =>
      (fieldErrors || [])
        .map((message) => `${fieldName}: ${message}`)
        .join(', ')
    )
    .join(', ');

  return detailsString.trim();
}

// Utility for showing success notification
export const showSuccessNotification = (
  openNotification: ReturnType<typeof useOpenNotification>,
  orderId: string
) => {
  openNotification({
    kind: 'success',
    message: TRANSLATIONS.CANCEL_ORDER_SUCCESS(orderId)
  });
};

// Utility for showing error notification
export const showErrorNotification = (
  openNotification: ReturnType<typeof useOpenNotification>,
  errorMsg: string
) => {
  openNotification({
    kind: 'error',
    message: `${TRANSLATIONS.CANCEL_ORDER_ERROR} - ${errorMsg}`
  });
};
